import { render, staticRenderFns } from "./Tournament2026.vue?vue&type=template&id=7c2a755d&scoped=true"
import script from "./Tournament2026.vue?vue&type=script&lang=js"
export * from "./Tournament2026.vue?vue&type=script&lang=js"
import style0 from "./Tournament2026.vue?vue&type=style&index=0&id=7c2a755d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a755d",
  null
  
)

export default component.exports